import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.season.modal');
import { HostListener, Input, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

type ModalStatus = 'error' | 'warning' | 'success';

@Component({
    selector: 'wiz-portal-season-modal',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.season.modal/view.scss */
:host {
  display: contents;
}

.season-modal-root {
  position: fixed;
  inset: 0;
  z-index: 10000;
  font-family: SUIT, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

.season-modal-backdrop {
  position: absolute;
  inset: 0;
  background: rgba(20, 32, 38, 0.48);
  backdrop-filter: blur(2px);
  animation: season-modal-fade 160ms ease-out both;
}

.season-modal-viewport {
  position: relative;
  display: flex;
  width: 100%;
  min-height: 100%;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.season-modal-card {
  --modal-state: #b42318;
  --modal-state-hover: #921f16;
  --modal-state-soft: #fff1f0;
  --modal-state-ring: rgba(180, 35, 24, 0.18);
  position: relative;
  width: min(560px, 100vw - 32px);
  overflow: hidden;
  border: 1px solid rgba(216, 226, 223, 0.92);
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 28px 72px rgba(22, 38, 34, 0.22), 0 8px 24px rgba(22, 38, 34, 0.12);
  color: #243c35;
  animation: season-modal-enter 190ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}
.season-modal-card.is-success {
  --modal-state: #18725f;
  --modal-state-hover: #125b4c;
  --modal-state-soft: #eaf7f2;
  --modal-state-ring: rgba(24, 114, 95, 0.18);
}
.season-modal-card.is-warning {
  --modal-state: #a15c08;
  --modal-state-hover: #824807;
  --modal-state-soft: #fff6df;
  --modal-state-ring: rgba(161, 92, 8, 0.2);
}

.season-modal-accent {
  height: 4px;
  background: var(--modal-state);
}

.season-modal-body {
  display: grid;
  grid-template-columns: 52px minmax(0, 1fr);
  gap: 18px;
  padding: 30px 30px 26px;
}

.season-modal-icon {
  display: grid;
  width: 52px;
  height: 52px;
  place-items: center;
  border-radius: 16px;
  background: var(--modal-state-soft);
  color: var(--modal-state);
}
.season-modal-icon svg {
  width: 27px;
  height: 27px;
}

.season-modal-copy {
  min-width: 0;
}

.season-modal-status {
  display: block;
  margin-bottom: 6px;
  color: var(--modal-state);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.03em;
}

.season-modal-copy h2 {
  margin: 0;
  color: #20352f;
  font-size: 20px;
  font-weight: 750;
  letter-spacing: -0.035em;
  line-height: 1.35;
}

.season-modal-copy p {
  max-height: min(38vh, 300px);
  margin: 10px 0 0;
  padding-right: 6px;
  overflow-y: auto;
  color: #63736e;
  font-size: 15px;
  font-weight: 450;
  letter-spacing: -0.018em;
  line-height: 1.7;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  word-break: keep-all;
}

.season-modal-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px 20px;
  border-top: 1px solid #e8efed;
  background: #f8faf9;
}

.season-modal-button {
  display: inline-flex;
  min-width: 96px;
  min-height: 44px;
  align-items: center;
  justify-content: center;
  padding: 0 18px;
  border: 1px solid transparent;
  border-radius: 11px;
  font: inherit;
  font-size: 14px;
  font-weight: 750;
  transition: background-color 150ms ease, border-color 150ms ease, box-shadow 150ms ease, transform 150ms ease;
}
.season-modal-button:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 4px var(--modal-state-ring);
}
.season-modal-button:active {
  transform: translateY(1px);
}
.season-modal-button.is-secondary {
  border-color: #cedbd7;
  background: #fff;
  color: #405851;
}
.season-modal-button.is-secondary:hover {
  border-color: #afc2bc;
  background: #f4f7f6;
}
.season-modal-button.is-primary {
  background: var(--modal-state);
  box-shadow: 0 7px 16px var(--modal-state-ring);
  color: #fff;
}
.season-modal-button.is-primary:hover {
  background: var(--modal-state-hover);
}

@keyframes season-modal-fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes season-modal-enter {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (max-width: 640px) {
  .season-modal-viewport {
    align-items: flex-end;
    padding: 12px;
  }
  .season-modal-card {
    width: 100%;
    border-radius: 20px 20px 16px 16px;
  }
  .season-modal-body {
    grid-template-columns: 44px minmax(0, 1fr);
    gap: 14px;
    padding: 24px 20px 22px;
  }
  .season-modal-icon {
    width: 44px;
    height: 44px;
    border-radius: 14px;
  }
  .season-modal-icon svg {
    width: 24px;
    height: 24px;
  }
  .season-modal-copy h2 {
    font-size: 18px;
  }
  .season-modal-copy p {
    font-size: 14px;
  }
  .season-modal-actions {
    flex-direction: column;
    gap: 8px;
    padding: 14px 16px 16px;
  }
  .season-modal-button {
    width: 100%;
  }
}
@media (prefers-reduced-motion: reduce) {
  .season-modal-backdrop,
  .season-modal-card {
    animation: none;
  }
  .season-modal-button {
    transition: none;
  }
}`],
})
export class PortalSeasonModalComponent implements OnInit {
    @Input() model: any = null;

    constructor(@Inject( Service) public service: Service) {
        if (!this.model) this.model = service.modal;
    }

    public async ngOnInit() {
    }

    public modalStatus(): ModalStatus {
        const status = `${this.model?.opts?.status || ''}`.trim().toLowerCase();
        return ['success', 'warning'].includes(status)
            ? status as ModalStatus
            : 'error';
    }

    public statusLabel() {
        const labels: Record<ModalStatus, string> = {
            success: '완료',
            warning: '확인 필요',
            error: '오류',
        };
        return labels[this.modalStatus()];
    }

    public modalTitle() {
        const title = `${this.model?.opts?.title || ''}`.trim();
        if (title) return title;
        const status = this.modalStatus();
        if (status === 'success') return '처리가 완료되었습니다';
        if (status === 'warning') return '진행 전 내용을 확인해주세요';
        const message = `${this.model?.opts?.message || ''}`;
        const failureWords = [
            '실패', '못했', '오류', '찾을 수 없', '저장하지 못', '불러오지 못',
        ];
        return failureWords.some((word: string) => message.includes(word))
            ? '요청을 완료하지 못했습니다'
            : '입력 내용을 확인해주세요';
    }

    public actionLabel() {
        const label = `${this.model?.opts?.action || ''}`.trim();
        return !label || label.toUpperCase() === 'OK' ? '확인' : label;
    }

    public cancelLabel() {
        const label = this.model?.opts?.cancel;
        return typeof label === 'string' && label.trim() ? label.trim() : '취소';
    }

    @HostListener('document:keydown.escape', ['$event'])
    public async closeWithEscape(event: KeyboardEvent) {
        if (!this.model?.isshow) return;
        event.preventDefault();
        if (this.model?.opts?.cancel) {
            await this.model.cancel();
            return;
        }
        await this.model.hide();
    }
}

export default PortalSeasonModalComponent;